export default __webpack_public_path__ + "static/meta-image-86b8b575f370fde192a3da53e56105e3.png";